import { render, staticRenderFns } from "./Podcastitems.vue?vue&type=template&id=45570ced&"
import script from "./Podcastitems.vue?vue&type=script&lang=js&"
export * from "./Podcastitems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports